import api from '@pray/shared/utils/api';

// Admin-only (PB-38023): restarts the AI content pipeline for one daily item —
// the same Deepgram → GPT-4o flow the podcast feed sync triggers — filling
// the item's quote, body, and reference without waiting for the ~1h sync-back.
export async function regeneratePrayRadioDailyAiContent({ dailyItemId }: { dailyItemId: string }) {
  if (!dailyItemId) throw Error('Daily Item ID is required');

  const url = `/web/studio/daily-items/${dailyItemId}/regenerate-ai-content`;
  const response = await api.executePostRequest(url, {});

  return response.data;
}
